import { render, staticRenderFns } from "./printLabelsStep.vue?vue&type=template&id=445fb28a&"
import script from "./printLabelsStep.vue?vue&type=script&lang=js&"
export * from "./printLabelsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAlert,VCheckbox})
